import { ReviewFormSource } from "@faire/web--source/common/consts/REVIEW_FORM_SOURCES";
import React from "react";

const DEFAULT_SOURCE = ReviewFormSource.brand_review_source_unknown;

export const BrandOrderReviewPageNavigationSourceContext =
  React.createContext<ReviewFormSource>(DEFAULT_SOURCE);

export const useBrandOrderReviewPageNavigationSourceContext = () => {
  return React.useContext(BrandOrderReviewPageNavigationSourceContext);
};
